import { isObject } from "lodash";

const modifyValues = <T>(object: T, modifier: (val: any, key: string) => any): T => {
  object = Object(object);
  const result: any = {};

  Object.keys(object).forEach((key) => (result[key] = modifier(object[key], key)));
  return result;
};

const regexIso8601 =
  /^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})\.(\d{1,})(Z|([-+])(\d{2}):(\d{2}))?)?)?)?$/;

const mapValuesDeep = (obj: any, cb: (value: string) => Date | string) => {
  if (Array.isArray(obj)) {
    return obj.map((innerObj) => mapValuesDeep(innerObj, cb));
  } else if (isObject(obj)) {
    return modifyValues(obj, (v) => mapValuesDeep(v, cb));
  } else {
    return cb(obj);
  }
};

export function reviveDatesCustomizer(value: string) {
  if (typeof value !== "string") {
    return value;
  }

  // return if value is 4 digits, otherwise regexIso8601 will treat it a a year
  if (value.match(/^\d\d\d\d$/)) {
    return value;
  }

  const match = value.match(regexIso8601);
  if (match) {
    const milliseconds = Date.parse(match[0]);

    if (!isNaN(milliseconds)) {
      return new Date(milliseconds);
    }
  }

  return value;
}

export function reviveDates<T>(obj: T): T {
  if (!obj) {
    return obj;
  }

  return mapValuesDeep(obj, reviveDatesCustomizer) as T;
}
